import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Card } from '@/components/sections/Card';
import { FunctionComponent } from 'react';

interface BundleUserGuideProps {}

const BundleUserGuide: FunctionComponent<BundleUserGuideProps> = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Bundles User Guide',
      to: ''
    }
  ];

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title="Bundles User Guide" breadcrumbs={breadcrumbs} />
      <div className="px-6 py-8 h-full text-lg space-y-5 overflow-y-auto">
        <Card className="p-5">
          <p>
            A bundle is a pre-configured set of equipment tailored to a specific role/department etc., making it easy to
            order everything a new employee needs with 'one click'. Create bundles and map them to job roles,
            departments, or use custom names.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default BundleUserGuide;
